module.exports = __webpack_public_path__ + "static/media/Thumbnail_HQ.c69980e7.png";